export const LAUNCH_DARKLY_FEATURE_FLAGS_MAP = {
  //* To configure the flag navigate to: https://app.launchdarkly.com/projects/candidate/flags/company-review-form-prod/targeting?env=production&env=staging&selected-env=production
  'company-review-form-prod': {
    key: 'company-review-form-prod',
    values: ['1.0.0', '2.0.0'],
    description:
      'Company Review Form Prod-Env 1st experiment (Old Existing V1, Next Simplified V2).',
  },
  //* To configure the flag navigate to: https://app.launchdarkly.com/projects/candidate/flags/company-review-form-experiment-2/targeting?env=production&env=staging&selected-env=production
  'company-review-form-experiment-2': {
    key: 'company-review-form-experiment-2',
    values: ['1.0.0', '3.0.0'],
    description:
      'Swap between the current form and experiment 2 which is a minimal input then multiple optional pages',
  },
} as const satisfies Record<
  string,
  { key: string; values: string[]; description?: string }
>;
export type LaunchDarklyFeatureFlagMap = typeof LAUNCH_DARKLY_FEATURE_FLAGS_MAP;
